//Custom states
export const registerStates = (states) => {

    states.customState = (state = {}, action) => {
        switch (action.type) {
            case 'SUBMENU_TOGGLED':
                return {
                    ...state,
                    submenu_id: action.id,
                };
            case 'MENU_CURRENT':
                return {
                    ...state,
                    submenu_id: -1,
                };
            case 'SCROLLED':
                return {
                    ...state,
                    scrolled: action.scrolled
                }
            default:
                return state;
        }
    };

    return states;
}